// extracted by mini-css-extract-plugin
export default {"section":"WithdrawalsSection_section__gMU8e","kpis":"WithdrawalsSection_kpis__iPzyX"};